/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */

import React from 'react';
import {Color, IconProps, IconSize} from '../types/types';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Asset Vehicle Icon component.
 */
export const AssetVehicleIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  const {stroke = undefined} = props;
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
      <path d='M13.015 6H4.007a.99.99 0 00-.712.305C3.106 6.5 3 6.764 3 7.04v7.663a1.067 1.067 0 00.295.734 1.002 1.002 0 00.712.303h1.578l.028-.073c.112-.33.321-.615.597-.818a1.6 1.6 0 01.945-.31 1.6 1.6 0 01.945.31c.276.203.485.488.597.818l.025.073h4.301a.907.907 0 00.124 0h.883V7.052a1.069 1.069 0 00-.294-.746A1.005 1.005 0 0013.015 6z'
        fill={iconColor}
        stroke={stroke} />
      <path d='M7.166 17.518c.674 0 1.22-.564 1.22-1.26 0-.696-.546-1.26-1.22-1.26-.673 0-1.22.564-1.22 1.26 0 .696.547 1.26 1.22 1.26zM17.374 17.518c.674 0 1.22-.564 1.22-1.26 0-.696-.546-1.26-1.22-1.26-.673 0-1.22.564-1.22 1.26 0 .696.547 1.26 1.22 1.26z'
        fill={iconColor}
        stroke={stroke} />
      <path d='M14.75 8.702v7.026h1.002l.022-.06c.116-.339.33-.632.615-.839.284-.207.623-.318.97-.318.348 0 .687.11.971.318.284.207.499.5.615.839l.022.06h1.772a.257.257 0 00.184-.077.274.274 0 00.077-.189V12.43a.268.268 0 00-.07-.183l-2.462-3.345A.631.631 0 0018 8.691h-3.25v.011z'
        fill={iconColor}
        fillRule='evenodd'
        clipRule='evenodd'
        stroke={stroke} />
    </svg>
  );
};
AssetVehicleIcon.defaultProps = {
  size  : IconSize.large,
  color : Color.grey4
};
